<h1 class="matp-page-title">テナント一覧</h1>

<!-- テナント一覧 -->
<mat-card class="matp-card">
  <app-tenant-list-table
    [tenantList]="tenantList"
    (created)="openTenantEditDialog()"
    (updated)="openTenantEditDialog($event)"
    (deleted)="deleteTenant($event)"
  >
  </app-tenant-list-table>
</mat-card>
